module.exports = __webpack_public_path__ + "static/media/intersection-counts-2010-2017-mod.8b87abdc.geojson";